export type Lang = 'hu' | 'en';

export const content = {
  hu: {
    greeting: 'Szia, én vagyok',
    tagline: 'Tesztautomatizáló mérnök',
    contactBtn: 'Kapcsolat',
    aboutTitle: 'Rólam',
    aboutText:
      'Tesztautomatizálással foglalkozom, célom hogy a szoftverek megbízhatóan és hibamentesen működjenek. Tapasztalatom van automatizált tesztek tervezésében, fejlesztésében és karbantartásában.',
    projectsTitle: 'Projektek',
    contactTitle: 'Kapcsolat',
    contactText: 'Írj nekem bármikor!',
    footer: '© 2026 Choristor. Minden jog fenntartva.',
  },
  en: {
    greeting: "Hi, I'm",
    tagline: 'Test Automation Engineer',
    contactBtn: 'Contact',
    aboutTitle: 'About Me',
    aboutText:
      'I specialize in test automation, ensuring software works reliably and without defects. I have experience designing, developing and maintaining automated test suites.',
    projectsTitle: 'Projects',
    contactTitle: 'Contact',
    contactText: 'Feel free to reach out anytime!',
    footer: '© 2026 Choristor. All rights reserved.',
  },
};
